import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import {
    CreateNotificationContent,
    NotificationContent,
    NotificationContentListResponse,
    NotificationContentQueryParams,
    UpdateNotificationContent
} from '@frontend/notification/types';

export class NotificationContentClient extends APIClient {
    public static readonly endpoint = '/notification-api/v1';

    public static async fetchNotificationContents(queryParams?: ApiQueryParams<NotificationContentQueryParams>): Promise<NotificationContentListResponse> {
        return await this.apiPaginated<NotificationContentListResponse, NotificationContentQueryParams>(`${this.endpoint}/contents`, queryParams);
    }

    public static async resolveNotificationContents(ids: string[], field: string = 'id'): Promise<NotificationContentListResponse> {
        return this.resolve<NotificationContentListResponse>(`${this.endpoint}/contents`, ids, field);
    }

    public static async deleteNotificationContents(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/contents-delete`, { ids: ids });
        return await this.handleVoidResponse(response);
    }

    public static async postNotificationContent(accountId: string, templateId: string, body: CreateNotificationContent): Promise<NotificationContent> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/templates/${templateId}/contents`, body);
        return await this.handleResponse<NotificationContent>(response);
    }

    public static async fetchAccountNotificationContent(accountId: string, templateId: string, contentId: string): Promise<NotificationContent> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/templates/${templateId}/contents/${contentId}`);
        return await this.handleResponse<NotificationContent>(response);
    }

    public static async patchNotificationContent(
        accountId: string,
        templateId: string,
        contentId: string,
        body: UpdateNotificationContent
    ): Promise<NotificationContent> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/templates/${templateId}/contents/${contentId}`, body);
        return await this.handleResponse<NotificationContent>(response);
    }

    public static async deleteNotificationContent(accountId: string, templateId: string, contentId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/templates/${templateId}/contents/${contentId}`);
        return await this.handleVoidResponse(response);
    }

    public static async previewNotificationContent(accountId: string, templateId: string, contentId: string): Promise<NotificationContent> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/templates/${templateId}/contents/${contentId}/preview`);
        return await this.handleResponse<NotificationContent>(response);
    }
}
